import _ from 'lodash';
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { format, /*subDays,*/ subMonths } from 'date-fns';

import { reducerCreator } from '@adrias-online/steiner/lib/helpers';

import { dataKeys } from '../helpers';
import { actionTypes } from '../actions/portaliStatistiche';
import { actionTypes as currentPortaleActionTypes } from '../../../actions/currentPortale';
import { getSectionForSourceAndUser } from '../sagas/portaliStatistiche';
import { getUser } from '../../../helpers/auth/reducer';

const startDate = format(subMonths(new Date(), 3), 'YYYY-MM-DD');
const endDate = format(new Date(), 'YYYY-MM-DD');

const DEFAULT_DATA_STATE = dataKeys.reduce((data, key) => {
    data[key] = {};

    if (key === 'overview') {
        data[key] = [];
    }

    return data;
}, {});

export const DEFAULT_STATE = Immutable({
    filters: {
        endDate,
        startDate,
        portaleId: null,
        hotelId: null,
        isFiltered: false,
        ga_medium: null
    },
    data: DEFAULT_DATA_STATE,
    loading: dataKeys.reduce((loading, key) => {
        loading[key] = true;

        return loading;
    }, {}),
    errors: dataKeys.reduce((errors, key) => {
        errors[key] = null;

        return errors;
    }, {})
});

function refreshAll(state) {
    const loading = dataKeys.reduce((data, key) => {
        data[key] = true;

        return data;
    }, {});

    const errors = dataKeys.reduce((data, key) => {
        data[key] = null;

        return data;
    }, {});

    return state.setIn(['loading'], loading).setIn(['errors'], errors);
}

function resetFilters(state) {
    return state.setIn(
        ['filters'],
        DEFAULT_STATE.filters.set('portaleId', state.filters.portaleId)
    );
}

function setData(state, action) {
    return state.setIn(['data', action.payload.key], action.payload.data);
}

function resetAll(state) {
    return state.set('data', DEFAULT_DATA_STATE);
}

function setError(state, action) {
    return state.setIn(['errors', action.payload.key], action.payload.error);
}

function setFilters(state, action) {
    return state.updateIn(['filters'], filters => ({
        ...filters,
        ...action.payload
    }));
}

function startLoading(state, action) {
    const key = action.payload.key;
    return state.setIn(['loading', key], true).setIn(['errors', key], null);
}

function stopLoading(state, action) {
    return state.setIn(['loading', action.payload.key], false);
}

function setContractYear(state, action) {
    return state.setIn(['contractYear'], action.payload);
}

function setPortale(state, action) {
    return state.setIn(['filters', 'portaleId'], action.payload.value);
}

const handlers = {
    [actionTypes.refreshAll]: refreshAll,
    [actionTypes.resetFilters]: resetFilters,
    [actionTypes.setData]: setData,
    [actionTypes.resetAll]: resetAll,
    [actionTypes.setError]: setError,
    [actionTypes.setFilters]: setFilters,
    [actionTypes.startLoading]: startLoading,
    [actionTypes.stopLoading]: stopLoading,
    [actionTypes.setContractYear]: setContractYear,
    [currentPortaleActionTypes.setPortale]: setPortale
};

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

const portaleIdSelector = state => state.portaliStatistiche.filters.portaleId;

const toDisplaySelector = createSelector(getUser, portaleIdSelector, () => {
    const sections = getSectionForSourceAndUser();

    return sections.reduce((result, key) => {
        result[key] = true;

        return result;
    }, {});
});

export const selectors = {
    getContractYear(state) {
        return state.portaliStatistiche.contractYear;
    },
    getData(state) {
        return state.portaliStatistiche.data;
    },
    getErrors(state) {
        return state.portaliStatistiche.errors;
    },
    // getFilters: finalFiltersSelector,
    getFilters(state) {
        return state.portaliStatistiche.filters;
    },
    getIsLoading(state) {
        const loading = _.transform(
            state.portaliStatistiche.loading,
            (result, value, key) => {
                if (value === true) {
                    result.push(key);
                }

                return result;
            },
            []
        );

        const validSections = getSectionForSourceAndUser();

        const loadingSections = _.intersection(loading, validSections);

        return loadingSections.length > 0;
    },
    getLoading(state) {
        return state.portaliStatistiche.loading;
    },
    getToDisplay: toDisplaySelector
};
